var _path, _path2, _path3, _path4, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShrink(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4112 6.18102C24.8137 6.58767 25.1013 6.87844 25.418 7.19818C23.5965 9.0179 21.7934 10.8215 19.9129 12.7013H23.1833V13.9824H17.7083V8.50181H18.9437V11.6616C20.7759 9.82582 22.5823 8.01576 24.4123 6.1821L24.4112 6.18102Z",
    fill: "url(#paint0_linear_1150_13469)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00678 6.02477C6.60428 6.43142 6.31663 6.72219 6 7.04193C7.82143 8.86164 9.6246 10.6653 11.5051 12.5451H8.23465V13.8262H13.7097V8.34556H12.4743V11.5054C10.6421 9.66957 8.83571 7.85951 7.0057 6.02584L7.00678 6.02477Z",
    fill: "url(#paint1_linear_1150_13469)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6023 20.3261C10.7433 22.1866 8.94228 23.9881 7.11549 25.8164C6.77954 25.4516 6.50584 25.1533 6.18814 24.8089C7.96449 23.0364 9.77518 21.2306 11.675 19.3347H8.37235V18.0611H13.8398V23.5546H12.6012V20.3261H12.6023Z",
    fill: "url(#paint2_linear_1150_13469)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0774 20.248C20.9364 22.1085 22.7374 23.91 24.5642 25.7383C24.9001 25.3735 25.1738 25.0752 25.4915 24.7308C23.7152 22.9583 21.9045 21.1525 20.0047 19.2566H23.3073V17.983H17.8398V23.4765H19.0785V20.248H19.0774Z",
    fill: "url(#paint3_linear_1150_13469)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 4.5,
    stroke: "url(#paint4_linear_1150_13469)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1150_13469",
    x1: 21.5631,
    y1: 6.18102,
    x2: 21.5631,
    y2: 13.9824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0D98C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE8888"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1150_13469",
    x1: 9.85483,
    y1: 6.02477,
    x2: 9.85483,
    y2: 13.8262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0D98C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE8888"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1150_13469",
    x1: 10.014,
    y1: 18.0611,
    x2: 10.014,
    y2: 25.8164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0D98C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE8888"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1150_13469",
    x1: 21.6657,
    y1: 17.983,
    x2: 21.6657,
    y2: 25.7383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0D98C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE8888"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1150_13469",
    x1: 15,
    y1: 1,
    x2: 15,
    y2: 29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0D98C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShrink);
export default __webpack_public_path__ + "static/media/shrink.5a520a6a17353c276ecd7e12804b1ace.svg";
export { ForwardRef as ReactComponent };